import { Image, useStyles, useTheme } from '@archipro-design/aria';
import type { LoadingValue } from '@archipro-design/aria';
import React, { useState } from 'react';
import * as S from './ImageSlide.style';
import type { Property } from 'csstype';

interface ImageSlideProps {
    libraryImage: string;
    onClick?: () => void;
    width: number;
    height: number;
    containerWidth?: number;
    containerHeight?: number;
    sizes?: string;
    loadingValue?: LoadingValue;
    objectFit?: Property.ObjectFit;
    objectPosition?: Property.ObjectPosition;
    isMultiplied?: boolean;
    alt?: string;
    quality?: number;
    isVideo?: boolean;
    caption?: string;
}

const ImageSlide = React.forwardRef<HTMLDivElement, ImageSlideProps>(
    (
        {
            libraryImage,
            isMultiplied,
            onClick,
            width,
            height,
            containerWidth,
            containerHeight,
            sizes,
            loadingValue = 'lazy',
            quality = 90,
            isVideo = false,
            caption,
            ...rest
        },
        ref
    ) => {
        const [isError, setIsError] = useState(false);
        const { css } = useStyles({
            width: containerWidth ?? width,
            height: containerHeight ?? height,
            isVideo,
            isError,
        });
        const theme = useTheme();

        return (
            <div ref={ref} className={css(S.PrimaryImageDesktopContainer)}>
                <Image
                    alt={rest.alt || ''}
                    src={libraryImage}
                    mixBlendMode={isMultiplied ? 'multiply' : 'normal'}
                    sizes={sizes}
                    width={width}
                    height={height}
                    layout={'responsive'}
                    objectFit="contain"
                    loading={loadingValue}
                    onClick={onClick}
                    onError={() => {
                        setIsError(true);
                    }}
                    quality={quality}
                    {...rest}
                    variables={{
                        placeholderBackgroundColorDark: 'transparent',
                        placeholderBackgroundColorLight:
                            theme.siteVariables.colors.white['200A'],
                    }}
                />
                {caption && <p className={css(S.ImageCaption)}>{caption}</p>}
            </div>
        );
    }
);

ImageSlide.displayName = 'ImageSlide';

export default ImageSlide;
